export default __webpack_public_path__ + "static/reusable_animation-9b4e0cb617c10797a7e12a25c57d53e8.gif";